<template>
  <div>
  <div class="mainDiv">
    <div class="login flex">
      <presentation />
      <div class="right-portion">
        <login-signup />
      </div>
    </div>
    <div class="logo">
        <Companies />
    </div>
  </div>
  <div class="mobile-view">
     <login-mobile />
  </div>
 
</div>
</template>

<script>
import loginSignupForm from "./components/login-signup-form.vue";
import krishfyPresentation from "./components/krishify-presentation.vue";
import trustedByCompanies from "./components/trustedCompanies.vue";
import loginPageMobile from "../LoginPageMobile/loginPage-mobile.vue"
import MoengageEventGenerator from "../../helpers/moengageEventGenerator";
import MoengageEvents from "../../helpers/moengageEvents";
import MoengageAtrributes from "../../helpers/moengageAttributes";
export default {
  name: "login",
  data() {
        return {
            isMobile: false,
        };
      },
  methods:{
    gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },
    checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
  },
  mounted(){
    this.checkDevices();
    localStorage.clear()
    const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"FALSE",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                        }
                        MoengageEventGenerator(MoengageEvents.LoginPageLoaded,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LoginPageLoaded,moengageAttr);

                        
  },
  components: {
    "login-signup": loginSignupForm,
    "presentation": krishfyPresentation,
    "Companies":trustedByCompanies,
    "login-mobile":loginPageMobile
  },
};
</script>

<style lang="scss" scoped>
.login {
  height: 70%;
}
.logo{
    height:30%;
}
.right-portion {
  width: 100%;
  padding: 0 15px;
  margin-top: auto;
}
.mainDiv{
    height: 100vh;
    @media all and (max-width: 1024px) {
      display:none;
    }

}
@media all and (min-width: 1000px) {
  .right-portion {
    width: 35%;
    margin-top: auto;
  }
}

@media all and (min-width: 1500px) {
  .right-portion {
    width: 25%;
  }
}
.mobile-view{
  height:100vh;
  @media all and (min-width: 1025px) {
    display:none;
  }

}
</style>
